<template>
  <div>
    <select
      @change="handleChange"
      :disabled="featureOptions.length === 0"
      class="px-3 py-2 border rounded appearance-none"
    >
      <option value="">Add feature</option>
      <option v-for="option in featureOptions" :key="option.value" :value="option.value">
        {{ option.label }}
      </option>
    </select>

    <table class="w-full">
      <tbody v-for="productFeature in productFeatures" :key="productFeature.feature_option_id">
        <tr>
          <td class="px-3 py-2 border">{{ productFeature.feature_option_display_name }}</td>
          <td class="px-3 py-2 border">{{ productFeature.feature_option_id }}</td>
          <td class="px-3 py-2 border">{{ productFeature.value }}</td>
          <td class="px-3 py-2 border">{{ productFeature.unit_amount }}</td>
          <td class="px-3 py-2 border">{{ productFeature.flat_amount }}</td>
          <td class="px-3 py-2 border">{{ productFeature.resettable_period }}</td>
        </tr>
      </tbody>
    </table>

    <pre v-text="features" />
  </div>
</template>

<script>
import { featuresClient } from '@/api/clients/admin';

export default {
  data() {
    return {
      features: [],
      activeFeatures: [],
      productFeatures: [],
    };
  },
  computed: {
    featureOptions() {
      return this.features
        .filter((feature) => {
          return this.activeFeatures.indexOf(feature.handle) === -1;
        })
        .map((feature) => ({
          label: feature.display_name,
          value: feature.handle,
        }));
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      featuresClient
        .list({
          include: 'options',
        })
        .then((r) => {
          this.features = r.data;

          r.data.forEach((feature) => {
            feature.options.forEach((option) => {
              this.productFeatures.push({
                feature_option_display_name: option.display_name,
                feature_option_id: option.id,
                value: 1,
                unit_amount: 0,
                flat_amount: 0,
                resettable_period: 'lifetime',
              });
            });
          });
        });
    },
    handleChange(ev) {
      if (this.activeFeatures.indexOf(ev.target.value) >= 0) {
        return;
      }

      this.activeFeatures.push(ev.target.value);

      ev.target.value = '';
    },
  },
};
</script>
